import React from 'react';

const socialLinks = [
  { name: 'GitHub', url: 'https://github.com/pavithra2870', icon: '🐙' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/pavithra-k-r-9b2a84314/', icon: '💼' },
  { name: 'LeetCode', url: 'https://leetcode.com/u/pavithrakr28/', icon: '🧩' },
  { name: 'Kaggle', url: 'https://www.kaggle.com/pavithrakr28', icon: '📊' },
  { name: 'CodeChef', url: 'https://www.codechef.com/users/pavithrakrvitc', icon: '🍳' },
  { name: 'Mail', url: 'mailto:pavithra6mail@gmail.com', icon: '✉️' },
];

const Footer = () => (
  <footer className="bg-gray-900 text-white py-6 mt-8">
    <div className="max-w-2xl mx-auto px-4 flex flex-col items-center">
      <div className="flex flex-wrap justify-center gap-4 mb-2">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-gray-800 text-white rounded-lg transition transform hover:scale-105 hover:bg-blue-500 hover:underline"
            title={link.name}
          >
            <span className="text-2xl">{link.icon}</span>
            <span className="hidden sm:inline text-base font-medium">{link.name}</span>
          </a>
        ))}
      </div>
      <div className="text-gray-400 text-sm mt-2">© {new Date().getFullYear()} Pavithra. All rights reserved.</div>
    </div>
  </footer>
);

export default Footer; 